import React from 'react';
import styled from 'styled-components';

import { getTranslatedString } from 'helpers/i18n';

import Form from 'components/ui/Form';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Spacer from 'components/ui/Spacer';
import TextBox from 'components/ui/TextBox';

const FullWidthTextArea = styled(TextBox.TextArea)`
  width: 100%;
`;

const FormTitle = styled.span`
  font-size: 20px;
  font-family: 'Circular-Bold';
`;

const StyledSectionContainer = styled.div``;

const ResidentComments = ({ handleChange, comment }) => (
  <StyledSectionContainer>
    <Spacer mb={1}>
      <FormTitle>
        {getTranslatedString('landlordPortal.maintenance.comments.startConversation')}
      </FormTitle>
    </Spacer>
    <Spacer mb={1}>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label={`${getTranslatedString('landlordPortal.maintenance.comments.comment')}`}
          >
            <FullWidthTextArea
              placeholder={getTranslatedString(
                'landlordPortal.maintenance.comments.internal.placeholder'
              )}
              size="large"
              name="tenant_note"
              onChange={handleChange}
              value={comment}
            />
          </Form.Item>
        </Col>
      </Row>
    </Spacer>
  </StyledSectionContainer>
);

export default ResidentComments;
